import request from '@/utils/request'


let CropSolutionApi = {
  /*分类管理*/
  cropSolutionList (data, errorback) {
    return request._postBody('/supplier/crop/solution/index', data, errorback)
  },

  addCropSolution (data, errorback) {
    return request._postBody('/supplier/crop/solution/add', data, errorback)
  },

  editCropSolution (data, errorback) {
    return request._postBody('/supplier/crop/solution/edit', data, errorback)
  },

  deleteCropSolution (data, errorback) {
    return request._post('/supplier/crop/solution/delete', data, errorback)
  },
  cropSolutionDetail (data, errorback) {
    return request._post('/supplier/crop/solution/detail', data, errorback)
  },
  getCountResult (data, errorback) {
    return request._postBody('/supplier/crop/solution/usage', data, errorback)
  },

  getCropSolutionType (data, errorback) {
    return request._postBody('/supplier/crop/solution/type', data, errorback)
  },
}

export default CropSolutionApi



// WEBPACK FOOTER //
// ./src/api/cropsolution.js